// src/utils/timeRangeLabels.js

export const comparisonLabels = {
    "": "previous period",
    day: "yesterday",
    yesterday: "the day before",
    week: "last week",
    last_week: "the week before last",
    month: "last month",
    last_month: "the month before last",
    last_six_months: "the previous 6 months",
    year: "last year",
    last_year: "the year before last",
  };
  
  /**
   * Returns a readable comparison label for a given time range.
   * @param {string} timeRange - The time range key (e.g. "month", "last_week").
   * @returns {string} - The corresponding comparison label.
   */
  export function getComparisonLabel(timeRange) {
    return comparisonLabels[timeRange] || "previous period";
  }
  